import cleanedFilename from '~/util/cleanedFilename';

export default {
  TICK: `${cleanedFilename(__filename)}-container`,
};
